import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckVendors } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { TCMVendorsOptions } from '@interfaces/cmModule/cmModule';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_VENDOR } from '@constants/queryKeys';

export const useQueryHistoryCheckVendors = () => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<TCMVendorsOptions[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_VENDOR],
		queryFn: extractQueryParams(getHistoryCheckVendors),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: (options) => optionsFormattedWithAvailability(options),
		...refetchOptions,
	});

	return {
		vendorsOptions: data || [],
		isFetchingVendorsOptions: isFetching,
		isLoadingVendorsOptions: (isLoading && !!data)
			|| isFetching,
	};
};
